import axios from 'axios';
import qs from 'qs';
import { createActionType } from 'utils/redux';
import { apiGetOpportunity, apiGetOpportunities, apiUpdateOpportunity } from 'constants/apiRouting';
import { handleErrors } from 'utils/api';
import { analyticsTrack } from 'utils/analytics';
import {
  GET_OPPORTUNITIES as GET_OPPORTUNITIES_EVENT,
  GET_OPPORTUNITY as GET_OPPORTUNITY_EVENT,
  CREATE_OPPORTUNITY as CREATE_OPPORTUNITY_EVENT,
  UPDATE_OPPORTUNITY as UPDATE_OPPORTUNITY_EVENT,
  // PATCH_OPPORTUNITY as PATCH_OPPORTUNITY_EVENT,
} from 'constants/analytics';


export const GET_OPPORTUNITIES = createActionType('GET_OPPORTUNITIES');
export const GET_OPPORTUNITY = createActionType('GET_OPPORTUNITY');
export const CREATE_OPPORTUNITY = createActionType('CREATE_OPPORTUNITIES');
export const UPDATE_OPPORTUNITY = createActionType('UPDATE_OPPORTUNITIES');
export const PATCH_OPPORTUNITY = createActionType('PATCH_OPPORTUNITIES');


export const getOpportunities = (params = {
  page: 1,
}) => async (dispatch) => {
  analyticsTrack(GET_OPPORTUNITIES_EVENT, {
    ...params,
  }, true);

  const response = await dispatch({
    type: GET_OPPORTUNITIES.name,
    payload: axios.get(apiGetOpportunities(), {
      params,
      withCredentials: true,
      paramsSerializer: p => qs.stringify(p),
    })
      .catch(error => handleErrors(error, dispatch)),
  });
  return response.value.data;
};

export const getOpportunity = oppId => async (dispatch) => {
  analyticsTrack(GET_OPPORTUNITY_EVENT, {
    oppId,
  }, true);

  const response = await dispatch({
    type: GET_OPPORTUNITY.name,
    payload: axios.get(apiGetOpportunity(oppId), {
      withCredentials: true,
    })
      .catch(error => handleErrors(error, dispatch)),
  });
  return response.value.data;
};


export const createOpportunity = opportunity => async (dispatch) => {
  analyticsTrack(CREATE_OPPORTUNITY_EVENT, {
    ...opportunity,
  }, true);
  await dispatch({
    type: CREATE_OPPORTUNITY.name,
    payload: axios.post(
      apiGetOpportunities(),
      opportunity,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const updateOpportunity = opportunity => async (dispatch) => {
  analyticsTrack(UPDATE_OPPORTUNITY_EVENT, {
    ...opportunity,
  }, true);
  await dispatch({
    type: UPDATE_OPPORTUNITY.name,
    payload: axios.put(
      apiUpdateOpportunity(opportunity.id),
      opportunity,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const patchOpportunity = (opportunity, data) => async (dispatch) => {
  analyticsTrack(UPDATE_OPPORTUNITY_EVENT, {
    ...opportunity,
  }, true);
  await dispatch({
    type: UPDATE_OPPORTUNITY.name,
    payload: axios.patch(
      apiUpdateOpportunity(opportunity.id),
      data,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};
